<template>
  <div style="overflow-x: hidden;">
    <v-row>
      <v-col cols="12" style="height: 80px;">
        <HeaderUSA v-if="getCountryCode === 'US'" />
        <HeaderCanada v-if="getCountryCode === 'CA'" />
      </v-col>
      <!-- </v-row>
    <v-row> -->
      <v-col cols="12" class="no-padding">
        <v-app id="v-app">
          <component :is="currentLayout">
            <transition name="fade" mode="out-in">
              <router-view />
            </transition>
          </component>
          <!-- Demo customization menu -->
          <!-- <customization-menu /> -->
        </v-app>
      </v-col>
      <v-col cols="12" class="no-padding">
        <FooterUSA v-if="getCountryCode === 'US'" />
        <FooterCanada v-if="getCountryCode === 'CA'" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DefaultLayout from "./Layouts/DefaultLayout";
import { mapGetters } from "vuex";
import HeaderUSA from "./components/headers/HeaderUSA";
import HeaderCanada from "./components/headers/HeaderCanada";
import FooterCanada from "./components/footer/FooterCanada";
import FooterUSA from "./components/footer/FooterUSA";
// Demo Menu
// import CustomizationMenu from '@/components/theme/CustomizationMenu'

export default {
  name: "App",
  components: {
    DefaultLayout,
    HeaderUSA,
    HeaderCanada,
    FooterUSA,
    FooterCanada,
    // CustomizationMenu
  },
  computed: {
    isRouterLoaded: function() {
      if (this.$route.name !== null) return true;
      return false;
    },
    currentLayout: function() {
      const layout = this.$route.meta.layout || "default";
      return layout + "Layout";
    },
    ...mapGetters(["getCountryCode"]),
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  margin-top: 60px;
}
.menu {
  background: linear-gradient(
      0deg,
      rgba(97, 97, 97, 0.3),
      rgba(7, 115, 140, 0.3)
    ),
    url(https://shipping-containers-images.s3-us-west-2.amazonaws.com/Shipping-Container-Cargo-Ship-on-Open-Seas-Green-Containers-800px.png)
      no-repeat center center fixed;
  /* background-repeat: no-repeat; */
  /* background-position: center bottom; */
  /* background-attachment: scroll; */
  background-size: cover;
  padding: 0;
}
.v-chip.v-size--small {
  border-radius: 50% !important;
}
.info {
  background-image: linear-gradient(60deg, #141e30, #243b55);
}
.main {
  /* color: white; */
  width: 100%;
  margin: auto;
  margin-top: 0%;
}

.no-space {
  margin: 0% !important;
  padding: 0% !important;
}
.pull-right {
  float: right;
}
.min-padding {
  padding: 2%;
}
.headers-style {
  text-align: center;
  margin: auto;
  width: 50%;  
}
.container {
  display: flex;
  justify-content: center;
  align-items: center;  
}
article {
  display: flex;
  flex-direction: column;
  margin: 10px;
  width: calc(100% - 20px);  
  perspective: 1000px;
}
article header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  background-color: #fff;  
  color: #000000;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2), 0 10px 10px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
article section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  color: #fff;
  background-color: #fff;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2), 0 10px 10px rgba(0, 0, 0, 0.2);
}
article section h2 {
  font-size: 1.4rem;
  font-weight: bolder;
  /* color: #df5c2e; */
  margin: 0;
  padding: 20px 40px 0px 40px;
}
article section .input-fields {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
}
article section .input-container {
  position: relative;
  padding: 30px 20px 20px 20px;
  width: calc(100% - 30px);
  /* max-width: 400px; */
}
article section .input-container input {
  position: relative;
  width: 100%;
  font-family: "Noto Sans", sans-serif;
  font-size: 1.35rem;
  outline: 0;
  background: transparent;
  box-shadow: none;
  border: none;
  /* border-bottom: 2px dashed; */
}
article section .input-container input:valid + .input-label {
  top: 10px;
  left: 20px;
  font-size: 0.7rem;
  font-weight: normal;
  /* color: #999; */
}
.black-text {
  color: #000000;
}
.green-text {
  color: #69cf0b !important;
}
article section .input-container input.wrong-input + .input-label {
  /* color: #b92938; */
}
article section .input-label {
  position: absolute;
  top: 32px;
  left: 20px;
  font-size: 1.35rem;
  pointer-events: none;
  transition: 0.2s ease-in-out;
}
article section .actions {
  margin: 30px 0 30px 0;
}
article section .actions button {
  font-family: "Noto Sans", sans-serif;
  outline: none;
  border: none;
  color: #fff;
  /* background-color: #df5c2e; */
  font-size: 1.35rem;
  padding: 5px 20px;
  margin: 0 10px;
  border-radius: 3px;
  cursor: pointer;
}
.animate-out {
  /* transform-origin: bottom left;
	animation: out 0.6s ease-in-out; */
  animation: slide-out 2s forwards;
}
.animate-in {
  /* transform-origin: top;
	animation: in 0.6s ease-in-out; */
  /* Standard syntax*/
  animation-duration: 1s;
  animation-name: slidein;
}
.animate-wrong {
  animation: wrong 0.4s ease-in-out;
}
@keyframes out {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  60% {
    transform: rotate(10deg);
  }
  100% {
    transform: translateY(1000px);
  }
}
@keyframes in {
  0% {
    opacity: 0;
    transform: rotateX(-90deg);
  }
  100% {
    opacity: 1;
    transform: rotateX(0deg);
  }
}
@keyframes wrong {
  0% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(40px);
  }
  40% {
    transform: translateX(20px);
  }
  60% {
    transform: translateX(40px);
  }
  80% {
    transform: translateX(20px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes showYtLink {
  0% {
    bottom: -200px;
  }
  100% {
    bottom: 20px;
  }
}
@keyframes slidein {  
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes slide-out {  
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.v-input--selection-controls .v-input__slot > .v-label {
  color: #000000 !important;
}

article .progress {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: inherit;
  background-color: #00587d;
}
article .progress .progress-track {
  position: absolute;
  top: 5px;
  width: 100%;
  height: 5px;
  background-color: #dfe3e4;
  z-index: -1;
}
article .progress .progress-step {
  position: relative;
  width: 100%;
  font-size: 12px;
  text-align: center;
  color: #fff;
  font-weight: bolder;
}
article .progress .progress-step:last-child:after {
  display: none;
}
article .progress .progress-step:before {
  content: "";
  display: flex;
  margin: 0 auto;
  margin-bottom: 10px;
  flex-wrap: wrap;
  align-content: center;
  width: 25px;
  height: 25px;
  background: #fff;
  border: 4px solid #dfe3e4;
  border-radius: 100%;
  color: transparent;
  position: inherit;
  z-index: 3;
}
article .progress .progress-step:after {
  content: "";
  position: absolute;
  top: 9px;
  left: 51%;
  width: 0%;
  transition: width 1s ease-in;
  height: 5px;
  background: #dfe3e4 !important;
  z-index: 2;
}
article .progress .progress-step.is-active {
  color: #ffffff;
  font-weight: bolder;
}
article .progress .progress-step.is-active:before {
  border: 4px solid #777;
  animation: pulse 2s infinite;
}
article .progress .progress-step.is-complete {
  color: #69cf0b;
}
article .progress .progress-step.is-complete:before {
  font-family: FontAwesome;
  font-size: 15px;
  color: #fff;
  background: #69cf0b;
  border: 4px solid transparent;
}
article .progress .progress-step.is-complete:after {
  background: #69cf0b !important;
  animation: nextStep 1s;
  animation-fill-mode: forwards;
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(33, 131, 221, 0);
  }
}
@keyframes nextStep {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
.no-padding {
  padding: 0px !important;
}
@media only screen and (max-width: 500px) {
  .headers-style {
    text-align: center;
    margin: auto;
    width: 100%;
  }
}
.fit-content {
  width: fit-content;
}
.v-btn-disabled-button {
  font-weight: bold;
  cursor: not-allowed;
  box-shadow: none;
  background-image: linear-gradient(45deg, grey, darkgrey, transparent);
}
.v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  margin-bottom: 0.5rem !important;
  margin-top: 0.5rem !important;
  bottom: 4px;
}
.v-radio,
.v-input__slot {
  align-items: baseline !important;
}
.fixed-top {
  z-index: 3 !important;
}

</style>
